<template>
  <div class="data-table" v-loading="loading" element-loading-text="Loading...">
    <el-table :header-cell-style="{background:'rgb(250, 250, 250)'}" :data="tableData"
              class="table-height"
              style="width: 100%;overflow-x: auto"
              :row-style="{ height: '65px' }"
              @select="handleSelectionChange"
              @select-all="handleSelectAll"
              :row-class-name="rowClassName"
    >

      <el-table-column type="selection" v-if="!showOperation"></el-table-column>

      <el-table-column prop="taskNumber" :label="$t('ProcessAfterSale.taskID')" min-width="180">
        <template v-slot="scope">
          <span class="link-text-style" @click="edit(scope.row)">{{ scope.row.taskNumber }}</span>
        </template>
      </el-table-column>
      <el-table-column prop="customerName" :label="$t('ProcessAfterSale.customerName')"
      ></el-table-column>
      <el-table-column prop="country" :label="$t('ProcessAfterSale.country')"></el-table-column>
      <el-table-column prop="brand" :label="$t('ProcessAfterSale.brandEBike')"></el-table-column>
      <el-table-column prop="organizationName" :label="$t('ProcessAfterSale.organizationName')"></el-table-column> 

      <el-table-column :label="$t('ProcessAfterSale.materialCode')">
        <template v-slot="scope">
          {{ scope.row.details && scope.row.details[0] ? scope.row.details[0].material_code || '' : '' }}
        </template>
      </el-table-column>
      <el-table-column :label="$t('ProcessAfterSale.errorType')">
        <template v-slot="scope">
          {{ scope.row.details && scope.row.details[0] ? scope.row.details[0].error_type || '' : '' }}
        </template>
      </el-table-column>
       <el-table-column prop="product_model" :label="$t('ProcessAfterSale.productModel')"
      ></el-table-column>
      <el-table-column prop="ram_code" :label="$t('ProcessAfterSale.ramCode')"
      ></el-table-column>
      <el-table-column prop="is_resolve" :label="$t('ProcessAfterSale.isResolved')"
      ></el-table-column>
      <el-table-column prop="market" :label="$t('ProcessAfterSale.market')"
      ></el-table-column>
      <el-table-column prop="progress" :label="$t('ProcessAfterSale.processingProgress')"
      ></el-table-column>
      <el-table-column prop="submissionTime" :label="$t('ProcessAfterSale.submitTime')"
      ></el-table-column>
      
      <el-table-column :label="$t('ProcessAfterSale.operation')" v-if="hasPermission('after_sale.delete')">
        <template v-slot="scope">
            <el-popconfirm :title="$t('ProductManage.ModelManage.sureDelete')" placement="top"
                        @confirm="handleDelete(scope.row)"
                         :confirm-button-text="$t('ProductManage.ModelManage.confirm')"
                         :cancel-button-text=" $t('ProductManage.ModelManage.cancel')"
                        confirm-button-type="success" width="250">
             <template #reference>
               <el-button link><span class="link-text-delete">{{ $t('ProductManage.ModelManage.delete') }}</span>
               </el-button>
             </template>
           </el-popconfirm>
        </template>
      </el-table-column>
    </el-table>
  </div>
</template>

<script>
import {defineComponent, reactive} from 'vue';
import {useRouter} from 'vue-router';
import {useI18n} from 'vue-i18n';
import {ElPopconfirm, ElMessage} from 'element-plus';
import {deleteAfterSalesData} from "@/api/api";
import resizeMixin from "@/mixins/resizeMixin";
import dialogMixin from "@/mixins/dialogMixin";

export default defineComponent({
  components: {
    ElPopconfirm
  },
  mixins: [resizeMixin, dialogMixin],

  setup() {
    const router = useRouter();
    const { t } = useI18n();
    
    const edit = (row) => {
      const DetailsPagePath = `/DetailsPage/${row.after_sales_id}`;
      router.push(DetailsPagePath);
    };
    
    const state = reactive({
      selectedRows: []
    });
    
    return {
      ...state,
      edit,
      t
    };
  },
  name: 'DataTable',
  props: {
    tableData: {},
    loading: Boolean,
    loadData: {
      type: Function,
    },
    showOperation: {
      type: Boolean,
      default: true
    },
  },
  created() {
    this.loadSubPermissions();
  },
  methods: {

    // 修改处理进度的状态功能已移除
    // 设置行的类名
    rowClassName({row}) {
      return this.selectedRows.some(selectedRow => selectedRow.after_sales_id === row.after_sales_id) ? 'row-selected' : '';
    },
    // 选中状态变化处理
    handleSelectionChange(selection) {
      // 获取所有勾选行的 after_sales_id
      const selectedIds = selection.map(item => item.after_sales_id);
      this.selectedRows = selection;
      this.$emit('selectedAftersalesIds', selectedIds);
    },
    handleSelectAll(selection) {
      const selectedIds = selection.map(item => item.after_sales_id);
      this.selectedRows = selection;
      this.$emit('selectedAftersalesIds', selectedIds);
    },
    // 删除按钮的点击事件处理函数
    async handleDelete(row) {
      try {
        // 用户确认后执行删除操作
        await deleteAfterSalesData(row.after_sales_id);
        // 调用父组件传递的loadData方法刷新表格数据
        if (typeof this.loadData === 'function') {
          this.loadData();
        }
        // 显示删除成功的提示
        ElMessage.success(this.$t('ProductManage.deleteSuccess'));
      } catch (error) {
        // 显示删除失败的提示
        ElMessage.error(this.$t('ProductManage.deleteFailed'));
        console.error('Delete failed:', error);
      }
    },

  },
});
</script>
<style scoped>

.data-table :deep( th) {
  background-color: rgb(250, 250, 250);
}

.data-table :deep(.link-text-delete) {
  color: #ff4d4f !important;
}

.data-table :deep(.link-text-style) {
  white-space: nowrap;
  word-break: keep-all;
}

.data-table {
  margin: 10px 20px; /* 设置默认的左右间隔 */

  @media (max-width: 768px) {
    margin: 5px 10px; /* 在小屏幕下减小间隔 */
  }

  @media (min-width: 769px) and (max-width: 1024px) {
    margin: 15px 30px; /* 在中等屏幕下增加间隔 */
  }

  /* 添加其他屏幕尺寸的媒体查询和 margin 设置 */
  }
  /* 状态选项相关样式已移除 */

/* 对于小屏幕设备（例如手机） */
@media (max-width: 768px) {
  .data-table {
    font-size: 14px;
    /* 调整字体大小 */
  }

}

/* 对于中等屏幕设备（例如平板电脑） */
@media (min-width: 769px) and (max-width: 1024px) {
  .data-table {
    font-size: 16px;
    /* 调整字体大小 */
  }
}

/* 你可以继续添加其他屏幕尺寸的规则 */
</style>